import { useState } from "react"
import { Box, Grid, Typography } from "@mui/material"

import { Next24, Nexttolast24, Prevtofirst24, Previous24 } from "../../components/icons/Icons"
import logoLoader from '../extra/camera-small.png'

const ITEMS_PER_PAGE = 9;
const ImageBox = ({ camera, onClick }) => {

    return (
        <Box onClick={onClick} className="menu-rounded shadow cam-over" sx={{ position: 'relative', height: { xs: 80, sm: 130 }, display: 'flex', alignItems: 'center', justifyContent: 'space-between', overflow: 'hidden' }}>
            <Box className="input-label" sx={{
                borderRadius: 1,
                fontSize: 12, position: 'absolute', py: 0.3, px: 0.5, top: 10, left: 10, backgroundColor: '#bababae0'
            }}>{camera?.camera_name}</Box>

            <img src={camera?.thumbnail || logoLoader}
                style={{ backgroundColor: '#313132' }} alt="" width={'100%'} height={'100%'}
                onError={(e) => { e.target.src = logoLoader }} />
        </Box>
    )
}
const CameraCard = ({ cameras = [], onCameraClick = (type, status) => { }, onTabClick = () => { } }) => {
    const [page, setPage] = useState(1);
    const [tab, setTab] = useState("timelapse");

    const totalPages = Math.ceil(cameras.length / ITEMS_PER_PAGE);

    const isFirst = page === 1;
    const isLast = page === totalPages;
    const onTabChange = (e, type) => {
        e.preventDefault();
        setTab(type)
        onTabClick(type);
        setPage(1);
        document.querySelector('.tab-active').classList.remove('tab-active');
        e.target.classList.add('tab-active');
    }
    const boxStyle = { height: 10, fontWeight: 600, fontSize: 16 }
    return (<>
        <Box className="rounded-lg shadow light-border" sx={{ p: 1, px: 2 }}>
            <Box sx={{ py: 1, px: 2, mb: 2, display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 4 }}>
                <Typography className="light-gray tab-active" sx={{ cursor: 'pointer', paddingBottom: 1 }} fontWeight={600} fontSize={18} onClick={(e) => onTabChange(e, 'timelapse')}>Timelapse cameras</Typography>
                <Typography className="light-gray" sx={{ cursor: 'pointer', paddingBottom: 1 }} fontWeight={600} fontSize={18} onClick={(e) => onTabChange(e, 'live')}>Live cameras</Typography>
                <Typography className="light-gray" sx={{ cursor: 'pointer', paddingBottom: 1 }} fontWeight={600} fontSize={18} onClick={(e) => onTabChange(e, 'ai')}>AI cameras</Typography>
            </Box>
            <Grid container spacing={1}>
                {cameras.slice(page, (page + 9))?.map((camera, index) => (
                    <Grid item size={{ xs: 6, sm: 4 }}>
                        <ImageBox camera={camera} onClick={() => onCameraClick(camera, tab)} />
                    </Grid>
                ))}
            </Grid>
            <Box sx={{ py: 2, px: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
                <Typography className="light-gray" sx={boxStyle} onClick={() => !isFirst && setPage(1)}> <Prevtofirst24 variant="filled" /> </Typography>
                <Typography className="light-gray" sx={boxStyle} onClick={() => !isFirst && setPage(p => p - 1)}><Previous24 variant="filled" /></Typography>
                <Typography className="light-gray" fontWeight={600} fontSize={16}>{String(page).padStart(2, "0")}</Typography>
                <Typography className="light-gray" fontWeight={600} fontSize={16}>{'/'}</Typography>
                <Typography className="light-gray" fontWeight={600} fontSize={16}>{String(totalPages).padStart(2, '0')}</Typography>
                <Typography className="light-gray" sx={boxStyle} onClick={() => !isLast && setPage(p => p + 1)}><Next24 variant="filled" /></Typography>
                <Typography className="light-gray" sx={boxStyle} onClick={() => !isLast && setPage(totalPages)}><Nexttolast24 variant="filled" /></Typography>
            </Box>
        </Box>
    </>
    )
}

export default CameraCard